import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";


// initial load form info 
const loadFormInfo = async (ACTIONS, formInfoDispatch, handleSelectChange, handleRadioChange, listValues, token) => {

  formInfoDispatch({
    type: ACTIONS.SET_INITIAL_DATA,
    data: '',
    loading: true
  })

  var status = STATUSES.SUCCESS;
  const url = "/api/organization/ws-account/new";
  const res = await http.post(url, {}, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    let selectedPSOOrg = null;
    if (res.status < 0) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: res.globalErrorMessageList });
    } else {

      selectedPSOOrg = listValues.psoOrgListValues(res.data);
    }
    return {
      selectedPSOOrg: selectedPSOOrg
    }

  }).then((obj) => {
    var data = {
      selectedPSOOrg: {
        value: '',
        options: obj.selectedPSOOrg,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleSelectChange,
        disabled: false,
        readOnly: false,
      },
      orgStatus: {
        radioButtons: [
          {
            id: "0",
            label: "Active",
            name: "orgStatus",
            value: 1,
            title: "Is Active Organization",
            isChecked: false,
            onChange: handleRadioChange,
            disabled: false
          },
          {
            id: "1",
            label: "Inactive",
            name: "orgStatus",
            value: 0,
            title: "Is Inactive Organization",
            isChecked: false,
            onChange: handleRadioChange,
            disabled: false
          }
        ],
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    })
  }).catch(function (error) {
    //console.log("CreateNewWebServiceAccount() error", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
};

// create WS account
const submitCreateWSAccount = async (token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  clearErrorMessages(formInfo.data);
  let idArray = ["", ""];
  // "orgId_psoId" from dropdown list item value
  if (getFieldValue("selectedPSOOrg", formInfo.data) && getFieldValue("selectedPSOOrg", formInfo.data) != null) {
    idArray = getFieldValue("selectedPSOOrg", formInfo.data).split("_");
  }

  var request = {
    action: "Add",
    password: "",
    ftpUserId: null,
    previousAccountStatusId: null,
    accountStatusId: getFieldValue("orgStatus", formInfo.data),
    orgId: Number(idArray[0]),
    psoId: idArray[1]
    //validationMode
  }

  var url = "/api/organization/ws-account/update";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    //console.log("submitCreateWSAccount()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {
      //console.log(`Key: ${key}, Value: ${value}`);

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitCreateWSAccount()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// auto ws pwd generator
const getGeneratePWD = async (getFieldValue, ACTIONS, formInfoDispatch, formInfo, handleRadioChange, handleInputTextChange, token, passedData) => {

  let wsId = "0";
  if (passedData) {
    wsId = passedData.ftpUserId.toString();
  }

  let body = { "wsId": wsId };

  let status = STATUSES.SUCCESS;

  let acctStatus = getFieldValue("orgStatus", formInfo.data);
  //console.log("acctStatus", acctStatus);
  const url = "/api/organization/ws-account/generate-pwd";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    let data = {
      orgStatus: {
        radioButtons: [
          {
            id: "0",
            label: "Active",
            name: "orgStatus",
            value: 1,
            title: "Is Active Organization",
            isChecked: acctStatus === 1,
            onChange: handleRadioChange,
            disabled: false
          },
          {
            id: "1",
            label: "Inactive",
            name: "orgStatus",
            value: 0,
            title: "Is Inactive Organization",
            isChecked: acctStatus === 0,
            onChange: handleRadioChange,
            disabled: false
          }
        ],
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
      },
      password: {
        value: res?.data,
        validation: {
          required: true,
          isInvalid: false,
          errors: []
        },
        onChange: handleInputTextChange,
        disabled: false,
      }
    }

    formInfoDispatch({
      type: ACTIONS.SET_INITIAL_DATA,
      data: data,
      loading: false
    })

    //console.log("getGeneratePWD()", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getGeneratePWD()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// edit ws account 
const submitEditWSAccount = async (token, wsAccountInfo, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

  //clearErrorMessages(formInfo.data);
  //console.log("wsAccountInfo", wsAccountInfo);
  const pwd = getFieldValue("password", formInfo.data);
  const previousAccountStatusId = wsAccountInfo.acctStatus === "Active" ? 1 : 0;

  var request = {
    action: "Update",
    password: pwd,
    ftpUserId: wsAccountInfo.ftpUserId,
    previousAccountStatusId: previousAccountStatusId,
    // admin: getFieldValue("orgStatus", formInfo.data)
    // level 3: previousAccountStatusId
    accountStatusId: getFieldValue("orgStatus", formInfo.data) !== null ? getFieldValue("orgStatus", formInfo.data) : previousAccountStatusId,
    orgId: wsAccountInfo.orgId,
    psoId: wsAccountInfo.psoId
    //validationMode
  }

  //console.log("submitEditWSAccount() request", request);

  var url = "/api/organization/ws-account/update";

  var status = STATUSES.SUCCESS;

  const res = await http.post(url, request, {
    headers: {
      "Authorization": token
    }
  }).then(res => {
    //console.log("submitEditWSAccount()", res);
    var x = 0;
    var isFirst = false;
    for (const [key, value] of Object.entries(nameConverter)) {

      var d = res.fieldErrors;
      var values = d[key];

      if (values != null) {
        if (x == 0) {
          isFirst = true;
        }
        else {
          isFirst = false;
        }
        addErrorMessages(value, key, res, isFirst);
        status = STATUSES.ERROR;
        x = x + 1;
      }
    }
    //console.log("submitEditWSAccount()", res);
    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from submitEditWSAccount()", error);
    status = STATUSES.ERROR;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// initial load edit ws page
const getWSAccountInfo = async (token, passedData) => {

  let wsId = "0";
  if (passedData) {
    wsId = passedData.ftpUserId.toString();
  }

  let status = STATUSES.SUCCESS;
  let body = { "wsId": wsId };

  const url = "/api/organization/ws-account/edit";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getWSAccountInfo()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// trigger pwd validation for password creation rules
const validateWSPwd = async (token, passedData, pwd, getFieldValue) => {

  let status = STATUSES.SUCCESS;
  let body = {
    "password": pwd,
    "selectedFtpUserId": passedData?.ftpUserId,
    "selectedPsoId": passedData?.psoId
  };

  //console.log("validateWSPwd() body", body);
  const url = "/api/organization/ws-account/validatePwd";
  const res = await http.post(url, body, {
    headers: {
      "Authorization": token
    }
  }).then((res) => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// generate ws acoount password history report
const generateWsaPwdHisRpt = async (token) => {

  let status = STATUSES.SUCCESS;

  const url = "/api/organization/ws-account/report";
  const res = await httpDownload.post(url, {}, {
    responseType: "blob",
    headers: {
      "Authorization": token
    }
  }).then((res) => {
    //console.log("generateWsaPwdHisRpt", res);
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {

    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

export { loadFormInfo, submitCreateWSAccount, getGeneratePWD, submitEditWSAccount, getWSAccountInfo, validateWSPwd, generateWsaPwdHisRpt }; 